import { sessionStore } from 'utils/storage'
import {
  AIDA_CONVERSATION_ID_KEY,
  AIDA_CONVERSATION_STARTING_NEW_KEY,
} from '../utils/constants/storage-keys'

export type AidaConversationSession =
  | { kind: 'new' }
  | { kind: 'selected'; id: string }
  | { kind: 'latest' }

function parseStartingNew(value: string | null): boolean | null {
  if (value === 'true') {
    return true
  }
  if (value === 'false') {
    return false
  }
  return null
}

export function openConversationId(
  session: AidaConversationSession,
  newestId: string | null,
  conversationsReady: boolean,
): string | null {
  if (session.kind === 'selected') {
    return session.id
  }
  if (session.kind === 'latest') {
    return conversationsReady ? newestId : null
  }
  return null
}

export function readAidaConversationSession(): AidaConversationSession | null {
  const selectedId = sessionStore.getString(AIDA_CONVERSATION_ID_KEY)
  const startingNew = parseStartingNew(sessionStore.getString(AIDA_CONVERSATION_STARTING_NEW_KEY))
  if (startingNew === true) {
    return { kind: 'new' }
  }
  if (startingNew === false && selectedId) {
    return { kind: 'selected', id: selectedId }
  }
  if (startingNew === false) {
    return { kind: 'latest' }
  }
  return null
}

export function writeAidaConversationSession(session: AidaConversationSession) {
  if (session.kind === 'selected') {
    sessionStore.setString(AIDA_CONVERSATION_ID_KEY, session.id)
  } else {
    sessionStore.remove(AIDA_CONVERSATION_ID_KEY)
  }
  sessionStore.setString(
    AIDA_CONVERSATION_STARTING_NEW_KEY,
    session.kind === 'new' ? 'true' : 'false',
  )
}

export function clearAidaConversationSession() {
  sessionStore.remove(AIDA_CONVERSATION_ID_KEY)
  sessionStore.remove(AIDA_CONVERSATION_STARTING_NEW_KEY)
}
